import { render, staticRenderFns } from "./sql__.vue?vue&type=template&id=4be43841&"
import script from "./sql__.vue?vue&type=script&lang=js&"
export * from "./sql__.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports